import { Mediator, app, payload, component } from "modular-openscriptjs";
import { eParse, processStart, processEnd } from "../helpers";
import { dc, gc, api } from "../declarations";
import { routes } from "../backendRoutes";

export class Analytics extends Mediator {
	$$analytics = {
		needs: {
			event: (ed, event) => this.sendEvent(ed, payload),
		},
	};

	$$user = {
		authenticated: (ed, event) => {
			gtag("config", dc.GA_PID, { user_id: gc.user.value.id });
		},

		loggedOut: (ed, event) => {},
	};

	async sendEvent(ed, ev) {
		let { message } = eParse(ed);

		const event = message.get("event");
		const params = message.get("params");

		gtag("event", event, { ...params });
	}
}
